export function getCachedKey(key: string, id: string) {
  return `${key}:${btoa(`${key}:${id}`)}`;
}
